import { createFileRoute } from '@tanstack/react-router'
import { KtpUploadForm } from '../../../components/KtpUploadForm'

export const Route = createFileRoute('/desa/$slug/verifikasi-ktp')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: KtpUploadPage,
})

function KtpUploadPage() {
  const { slug } = Route.useParams()
  const { token } = Route.useSearch()
  return <KtpUploadForm slug={slug} token={token} />
}
